import { tokenTypes } from '../Constants.js';
import Factory from './Factory.js';
import Util from './Util.js';
export default {
  type: 'ExpressionField.comparator',
  tokenize: (field, context) => {
    if (!field?.absoluteLocation) {
      return null;
    }
    return [
    // tokenize left
    ...Factory.create(field.left, context), {
      startIndex: field.comparatorLocation.absoluteIndex,
      endIndex: field.comparatorLocation.absoluteIndex + field.comparator.length,
      type: tokenTypes.OPERATOR
    },
    // tokenize right
    ...Factory.create(field.right, context), ...Util.handleAlias(field, context)];
  }
};